export default __webpack_public_path__ + "static/media/SD-annadanam-icon.707f76f8.svg";